<template>
  <div class="student-record-statistics">
    <!-- 头部 -->
    <div class="info-operation-container">
      <div class="info-search-container">
        <el-button size="small" @click="$router.back()">返回</el-button>
        <!-- <el-date-picker class="select" v-model="schoolYearVal" type="year" value-format="yyyy" placeholder="学年">
        </el-date-picker> -->
        <year-range-picker class="select" style="width: 300px; margin-left: 20px" v-model="schoolYearVal" />
        <el-select class="select" v-model="semesterVal" placeholder="学期" clearable>
          <el-option v-for="item in semesterOptions" :key="item.dictValue" :label="item.dictLabel"
            :value="item.dictValue">
          </el-option>
        </el-select>
        <el-button type="primary" style="margin-left: 20px;" size="small"
          @click="selectTeacherAllotStatistics">搜索</el-button>
        <search class="search" placeholder="请输入教师名称" @search="teacherSearch" />
      </div>
      <div class="operation-part-container">
        <el-button type="success" size="small" @click="exportTeacherAllotStatistics">导出</el-button>
      </div>
    </div>
    <!-- 列表栏容器 -->
    <div class="info-table-container" v-bitmap="listGetResult">
      <statisticalList :teacherList="teacherList" />
    </div>
    <div class="pagination-catainer">
      <pagination :total="parseInt(total)" :pageSize="parseInt(pageInfo.pageSize)"
        @currentPageNumChange="currentPageNumChange" @handleSizeChange="handleSizeChange" />
    </div>
  </div>
</template>

<script>
import search from "@/components/search/search.vue";
import statisticalList from "./components/statistical-list/statisticalList.vue";
import { baseURL } from "@/api/request";
export default {
  components: {
    search,
    statisticalList
  },
  data() {
    return {
      // // 处理后的班级年级多选数据
      // classSelect: [],
      // // 级联选择器属性配置
      // classProps: {
      //   expandTrigger: "hover",
      //   children: "schoolClassList",
      // },
      // // 选中后的班级年级
      // className: [],
      // // 班级年级数据
      // classSelectList: [],
      // classPlaceholder: "请选择班级",
      schoolYearVal: "",
      semesterVal: "",
      semesterOptions: [],
      total: 0,
      pageInfo: {
        pageSize: 10,
        pageNum: 1,
      },
      // 统计列表
      teacherList: [],
      teacherName: "",
      listGetResult: "success",
    }
  },
  created() {
    this.getSemesterType();
    this.selectTeacherAllotStatistics();
  },
  methods: {
    teacherSearch(e) {
      this.teacherName = e;
      this.selectTeacherAllotStatistics();
    },
    // 导出
    exportTeacherAllotStatistics() {
      let action = `${baseURL}${this.$url.exportTeacherAllotStatistics}?schoolYear=${this.schoolYearVal}&semester=${this.semesterVal}&teacherName=${this.teacherName}`;
      this.$downloadFile(action);
    },
    // 获取学期类型选择列表数据
    getSemesterType() {
      this.get(`${this.$url.getDictType}/semester_type`).then((res) => {
        // console.log("学期类型==>", res);
        this.semesterOptions = res.data;
      });
    },
    // 分页组件传递过来的页码修改事件
    currentPageNumChange(pageNum) {
      this.pageInfo.pageNum = pageNum;
      this.selectTeacherAllotStatistics();
    },
    handleSizeChange(pageSize) {
      this.pageInfo.pageSize = pageSize;
      this.selectTeacherAllotStatistics();
    },
    selectTeacherAllotStatistics() {
      let data = {
        schoolYear: this.schoolYearVal,
        semester: this.semesterVal,
        teacherName: this.teacherName,
        pageNum: this.pageInfo.pageNum,
        pageSize: this.pageInfo.pageSize,
      };
      this.get(this.$url.selectTeacherAllotStatistics, data).then(res => {
        if (res.code !== 200) return this.$message.error(res.msg);
        // console.log("统计列表", res);
        this.teacherList = res.rows;
        this.total = res.total;
      });
    },
  }
};
</script>

<style lang="scss" scoped>
@import "./studentRecordStatistics.scss";
</style>